function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n.a{stroke:none}\n.a,.b{fill:none;}\n.b{stroke:current;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:2px;}\n"));

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  className: "a",
  width: 26.18,
  height: 26.18
});

var _ref4 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(8.727 5.454)"
}, /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M0,0,4.363,4.363,0,8.727",
  transform: "translate(0 4.363) rotate(-90)"
}), /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M0,0,4.363,4.363,0,8.727",
  transform: "translate(8.727 10.908) rotate(90)"
}));

function SvgArrowList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.18,
    height: 26.18,
    viewBox: "0 0 26.18 26.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowList);
export default __webpack_public_path__ + "static/media/arrow-list.73eea2d4.svg";
export { ForwardRef as ReactComponent };